export { default as withReduxStore } from './withReduxStore';
